export const typeToName = (type: any, value: any) => {
  if (type[value]) return type[value].name;
  else return "값 오류";
};

export const isNumber = (target: string | number) => {
  return !isNaN(target as number);
};
